
import { defuFn } from '/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/home/forge/test-konfigurator.smartdusche.com/releases/20260601110802/client/nuxt-core/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
